import cn from "classnames";
import Link from "next/link";

import classes from "./styles.module.scss";

export default function ({ className, href, children }) {
  return (
    <Link className={cn(className, classes.Back)} href={href}>
      <img src="/assets/ChevronLeft.svg" width="10" height="11" alt="" />
      {children}
    </Link>
  );
}
